var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      minWidth: 17
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7586 4.73165L12.268 1.24024C12.1519 1.12414 12.0141 1.03204 11.8624 0.969201C11.7107 0.906365 11.5482 0.874023 11.384 0.874023C11.2198 0.874023 11.0572 0.906365 10.9056 0.969201C10.7539 1.03204 10.6161 1.12414 10.5 1.24024L0.866412 10.8746C0.749834 10.9903 0.657407 11.1279 0.594506 11.2796C0.531604 11.4313 0.499482 11.594 0.500006 11.7582V15.2496C0.500006 15.5811 0.631702 15.8991 0.866123 16.1335C1.10054 16.3679 1.41849 16.4996 1.75001 16.4996H5.24141C5.40563 16.5001 5.5683 16.468 5.71999 16.4051C5.87168 16.3422 6.00935 16.2498 6.12501 16.1332L15.7586 6.49962C15.8747 6.38354 15.9668 6.24573 16.0296 6.09405C16.0925 5.94238 16.1248 5.77981 16.1248 5.61563C16.1248 5.45146 16.0925 5.28889 16.0296 5.13721C15.9668 4.98554 15.8747 4.84772 15.7586 4.73165ZM5.24141 15.2496H1.75001V11.7582L8.62501 4.88321L12.1164 8.37462L5.24141 15.2496ZM13 7.49024L9.5086 3.99962L11.3836 2.12462L14.875 5.61524L13 7.49024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.5936339e7a863cea580406967aaae232.svg";
export { ForwardRef as ReactComponent };